module.exports = __webpack_public_path__ + "img/climate_change.e9c71447.svg";